import React from 'react';

const FeaturedContentFormModal = React.lazy(() => import('../components/FormModal'));
const featuredContentModalRegistry = {
    community_featuredContentId: FeaturedContentFormModal
};
export default featuredContentModalRegistry;
